/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {StoricoRisultatiWidget} from '../../../_metronic/partials/widgets/customs/StoricoRisultatiWidget'

export function Storico_risultati() {
  return (
    <>	
      <div className='col-xl-12'>
        <StoricoRisultatiWidget className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </>
  )
}
